// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OhT7q","right":"styles_right__2Sxi4"};